/*
 * Awaiting-the-CI-client panel: pure model, no React. The attach deadline, whether it passed and the client execution
 * fields worth showing (only those the SDK reported).
 */
import type { Build } from '@/api/schemas';

export type ClientExecution = NonNullable<Build['clientExecution']>;

/** The attach deadline: the SDK's own, else the build's, else none. */
export const attachDeadline = (b: Pick<Build, 'clientExecution' | 'deadlineAt'>): string | null => b.clientExecution?.attachDeadline ?? b.deadlineAt ?? null;

export const deadlineExpired = (deadline: string | null, now: number): boolean => (deadline ? new Date(deadline).getTime() <= now : false);

export interface ExecutionField {
  label: string;
  value: string;
  /** Classes of the wrapper `div` (the command takes both columns). */
  wrapperClass?: string;
  /** Classes of the value `dd`. */
  valueClass: string;
}

/** The command, working directory and the eas.json profile the SDK reported, in that order; unset ones are left out. */
export function executionFields(exec: ClientExecution): ExecutionField[] {
  const fields: Array<ExecutionField | null> = [
    exec.command ? { label: 'command', value: exec.command, wrapperClass: 'sm:col-span-2', valueClass: 'break-all text-foreground' } : null,
    exec.workingDirectory ? { label: 'working directory', value: exec.workingDirectory, valueClass: 'text-muted-foreground' } : null,
    exec.easProfile ? { label: 'profile in eas.json', value: exec.easProfile, valueClass: 'text-muted-foreground' } : null,
  ];
  return fields.filter((f): f is ExecutionField => f !== null);
}
